export default function($) {
  $(document).ready(function(){

    if ($("#js-privacy-policy-remote-content").length) {
      var document_to_load_url = $("#js-privacy-policy-remote-content").data('remote-url')
      var id_to_load = $("#js-privacy-policy-remote-content").data('remote-id')

      $("#js-privacy-policy-remote-content").load(
        document_to_load_url + " " + id_to_load,
        function() {
          if ($("#js-privacy-policy-remote-content #content").length) {
            $('#js-privacy-policy-remote-content #content').attr('id','remote-content');

            // reset remote content style
            $('#js-privacy-policy-remote-content #remote-content').removeAttr('class');
          }
        }
      );
    }

  })
}
